var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 4.5C7.36533 4.5 4 7.86533 4 12C4 16.1347 7.36533 19.5 11.5 19.5C15.6347 19.5 19 16.1347 19 12C19.0012 11.9172 18.9859 11.835 18.955 11.7581C18.9241 11.6812 18.8783 11.6113 18.8201 11.5523C18.7619 11.4933 18.6927 11.4465 18.6162 11.4145C18.5398 11.3826 18.4578 11.3661 18.375 11.3661C18.2922 11.3661 18.2102 11.3826 18.1338 11.4145C18.0573 11.4465 17.9881 11.4933 17.9299 11.5523C17.8717 11.6113 17.8259 11.6812 17.795 11.7581C17.7641 11.835 17.7488 11.9172 17.75 12C17.75 15.4591 14.9591 18.25 11.5 18.25C8.04092 18.25 5.25 15.4591 5.25 12C5.25 8.54092 8.04092 5.75 11.5 5.75C13.07 5.75 14.494 6.33189 15.5906 7.28442L14 8.875H17.75V5.125L16.4756 6.39941C15.1503 5.22211 13.4087 4.5 11.5 4.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.63055b669c91c8f4edb526561f7484b4.svg";
export { ForwardRef as ReactComponent };